import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dcebc8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "OkAudioRecordMini__container" }
const _hoisted_3 = { class: "container__toggle cursor-pointer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0.601562",
  y: "0.5",
  width: "4",
  height: "12",
  fill: "black"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "6.60156",
  y: "0.5",
  width: "4",
  height: "12",
  fill: "black"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0.601562 12.5V0.5L10.6016 6.5L0.601562 12.5Z",
  fill: "black"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "container__time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkAudioRecordMini", { 'OkAudioRecordMini--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("audio", {
      ref: "audioPlayer",
      src: _ctx.url,
      style: {"display":"none"},
      onTimeupdate: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onUpdateTime && _ctx.onUpdateTime(...args))),
      onEnded: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAudioEnded && _ctx.onAudioEnded(...args)))
    }, null, 40, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.playing)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              width: "11",
              height: "13",
              viewBox: "0 0 11 13",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              style: {"min-width":"11px","min-height":"13px"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
            }, _hoisted_6))
          : (_openBlock(), _createElementBlock("svg", {
              key: 1,
              width: "11",
              height: "13",
              viewBox: "0 0 11 13",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              style: {"min-width":"11px","min-height":"13px"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
            }, _hoisted_8))
      ]),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formatTime(_ctx.currentTime)) + " / " + _toDisplayString(_ctx.formatTime(_ctx.duration)), 1)
    ])
  ], 2))
}